module.exports = __webpack_public_path__ + "static/media/light-theme-neutral-duration.9b872265.svg";